import { render, staticRenderFns } from "./accidentReportUpdate.vue?vue&type=template&id=0c0f5018&scoped=true"
import script from "./accidentReportUpdate.vue?vue&type=script&lang=js"
export * from "./accidentReportUpdate.vue?vue&type=script&lang=js"
import style0 from "./accidentReportUpdate.vue?vue&type=style&index=0&id=0c0f5018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f5018",
  null
  
)

export default component.exports